"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var legacy_1 = require("satcheljs/lib/legacy");
exports.default = legacy_1.action('setFindResultSet')(function setFindResultSet(viewstate, findResultSet) {
    viewstate.findResultSet = findResultSet;
});
//# sourceMappingURL=setFindResultSet.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/setFindResultSet.js
// module id = 2780
// module chunks = 2 3 4 45